import React from 'react';
import { Box, styled } from 'bonfire-kindling';

const StickyBox = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  bottom: '0',
  boxShadow: theme.shadows[1],
  display: 'flex',
  height: '4.25rem',
  left: '0',
  right: '0',
  padding: `${theme.spacing(3)}px ${theme.spacing(5)}px`,
  position: 'fixed',
  width: 'auto',
}));

const StickyBar = ({ children, ...props }) => {
  return <StickyBox {...props}>{children}</StickyBox>;
};

export default StickyBar;
